import React, { useEffect, useState } from 'react'
import { ColumnNormal } from '../../ReportComponent/components/Model'
import PageIncidentService from './PageIncidentService'
import { Table, Tooltip } from 'antd'

interface Param {
    dataTransfer: any[]
    columnsTicketPendingList: string[]
    columnsTicketPendingObjList: ColumnNormal[]
    total: number
    range: any
    handleTicketPendingChange: Function
}

type Props = Param
const ColumnTicketPending: React.FC<Props> = (props: Props) => {
    const [tempColumns, setTempColumns] = useState<ColumnNormal[]>([])
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(10)

    useEffect(() => {
        if (props.columnsTicketPendingList && props.columnsTicketPendingObjList) {
            const temp: ColumnNormal[] = []
            props.columnsTicketPendingList.forEach((it) => {
                const findDataIndex = props.columnsTicketPendingObjList.find((data) => data.dataIndex === it)
                if (findDataIndex) {
                    findDataIndex.render = (text, record) => {
                        return (<>
                            <Tooltip placement="bottom" title={text?.length > 50 ? text : null}>
                                {text !== null && text?.toString()?.length > 50 ? text?.toString().substring(0, 50) + '...' : text?.toString()}
                            </Tooltip>
                        </>)
                    }
                    temp.push(findDataIndex)
                }
            })
            setTempColumns(temp)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.columnsTicketPendingList, props.columnsTicketPendingObjList])

    useEffect(() => {
        if (pageSize) {
            PageIncidentService.getInstance().data.pageTicketPending = 1
            setPage(1)
            props.handleTicketPendingChange()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageSize])

    useEffect(() => {
        if (!props.range) {
            setPage(1)
            PageIncidentService.getInstance().data.pageTicketPending = 1
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.range])

    const handleOnClickPageNumber = (page: number) => {
        setPage(page)
        PageIncidentService.getInstance().data.pageTicketPending = page
        props.handleTicketPendingChange()
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setPageSize(pagination.pageSize)
        PageIncidentService.getInstance().data.pageSizeTicketPending = pagination.pageSize
    }

    return (
        <div>
            <Table scroll={{x: true}} dataSource={tempColumns.length === 0 ? [] : props.dataTransfer} columns={tempColumns}
                pagination={ props.range && props.columnsTicketPendingList.length !== 0 ? {
                    current: page,
                    pageSize: pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '20', '30', '40'],
                    total: props.dataTransfer.length !== 0 ? props.total : 0,
                    onChange: (event) => {
                        handleOnClickPageNumber(event)
                    }
                } : false}
                onChange={handleTableChange}
                className="ReportTable" rowKey={'serialNumber'}/>
        </div>
    )
}

export default ColumnTicketPending
